export default __webpack_public_path__ + "static/media/empty-radiology.508fc452.svg";